import React, { useState, useEffect } from 'react';
import { getAppreciations } from '../../services/appreciationService';
import AppreciationCard from './AppreciationCard';

const AppreciationList = () => {
  const [appreciations, setAppreciations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [skip, setSkip] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const LIMIT = 20;

  useEffect(() => {
    const fetchAppreciations = async () => {
      try {
        setLoading(true);
        const data = await getAppreciations(0, LIMIT);
        setAppreciations(data);
        setSkip(LIMIT);
        setHasMore(data.length === LIMIT);
      } catch (error) {
        console.error('Error fetching appreciations:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchAppreciations();
  }, []);

  const loadMore = async () => {
    try {
      setLoadingMore(true);
      const data = await getAppreciations(skip, LIMIT);
      setAppreciations(prev => [...prev, ...data]);
      setSkip(prev => prev + LIMIT);
      setHasMore(data.length === LIMIT);
    } catch (error) {
      console.error('Error loading more appreciations:', error);
    } finally {
      setLoadingMore(false);
    }
  };

  if (loading) {
    return <div className="text-center py-10">Loading appreciations...</div>;
  }

  return (
    <div className="mt-8">
      <div className="flex items-center justify-between mb-5">
        <h2 className="text-xl font-semibold text-gray-900">Recent Appreciation Activity</h2>
        {/* Filtering: Future feature */}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {appreciations.length > 0 ? (
          appreciations.map(appreciation => (
            <AppreciationCard key={appreciation.id} appreciation={appreciation} />
          ))
        ) : (
          <div className="col-span-3 text-center py-10 text-gray-500">
            No appreciations found. Be the first to send one!
          </div>
        )}
      </div>

      {hasMore && appreciations.length > 0 && (
        <div className="flex justify-center mt-8">
          <button
            onClick={loadMore}
            disabled={loadingMore}
            className="px-6 py-2 bg-white border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loadingMore ? 'Loading...' : 'Load More'}
          </button>
        </div>
      )}
    </div>
  );
};

export default AppreciationList;
